import BackgroundTiles from './BackgroundTiles';

export { BackgroundTiles };
